/* The side panel's small player: the clip's box at the poster's size, one control row, the composer
 * and the door into the full player. Every row stands from the first frame, so starting the film
 * moves nothing. The scrubber, the icon buttons and the film notice are `ClipPlayer.module.css`'s. */

.mini {
  display: flex;
  flex-direction: column;
  gap: var(--space-10px);
  min-width: 0;
}

/* Never cropped: the box takes the clip's own ratio, capped at the poster's height. */
.box {
  position: relative;
  align-self: center;
  width: min(100%, calc(var(--h-forma-dock-poster) * var(--clip-ratio)));
  aspect-ratio: var(--clip-ratio);
  overflow: hidden;
  background: var(--player-stage);
  border-radius: var(--radius-12px);
}

.video {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.poster {
  position: absolute;
  inset: var(--space-0);
  display: block;
  width: 100%;
  height: 100%;
}

.surface {
  position: absolute;
  inset: var(--space-0);
  display: grid;
  place-items: center;
  padding: var(--space-0);
  cursor: pointer;
  background: transparent;
  border: 0;
}

.play {
  display: grid;
  place-items: center;
  width: var(--sz-forma-play);
  height: var(--sz-forma-play);
  color: var(--text-on-photo);
  background: var(--wash-on-photo-strong);
  border-radius: var(--r-circle);
}

.playGlyph {
  width: var(--space-22px);
  height: var(--space-22px);
}

.row {
  display: flex;
  gap: var(--space-2);
  align-items: center;
}

.scrubber {
  flex: 1;
  min-width: 0;
}

.clock {
  flex: none;
  font-size: var(--fs-label);
  font-weight: var(--fw-semibold);
  color: var(--text-2);
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

.composer {
  display: flex;
  gap: var(--space-6px);
  align-items: center;
}

.field {
  flex: 1;
  min-width: 0;
  height: var(--h-control-field);
  padding: var(--space-0) var(--space-3);
  font: inherit;
  font-size: var(--fs-button-sm);
  color: var(--text);
  background: var(--bg-inset);
  border: var(--border-hairline) solid var(--border-2);
  border-radius: var(--radius-sm);
  outline: none;
}

.field:focus {
  border-color: var(--border-3);
}

.open {
  justify-content: center;
  width: 100%;
  height: var(--h-forma-dock-open);
  padding: var(--space-0) var(--space-3);
  font-size: var(--fs-body);
  font-weight: var(--fw-bold);
  color: var(--text);
  background: var(--bg-card);
  border-radius: var(--radius-sm);
}

/* The composer, its refusal and the door: in the dock a part of the one column, on a card the
 * column beside the film. */
.side {
  display: contents;
}

/* ── On a task card ──────────────────────────────────────────────────────────────────────────── */

/* The film and its control row on the left at one fixed height, so nothing moves when the clip's
 * read lands; what the task is about, the reply and „Analizuj" on the right. The left column is never
 * narrower than a control row can be read at, and a portrait film stands centred in it. */
.card {
  display: grid;
  grid-template-columns: minmax(var(--w-task-clip-column), auto) minmax(0, 1fr);
  gap: var(--space-10px) var(--space-6);
  align-items: start;
}

.card .box {
  grid-row: 1;
  grid-column: 1;
  justify-self: center;
  width: auto;
  height: var(--h-task-clip-box);
}

.card .row {
  grid-row: 2;
  grid-column: 1;
  height: var(--h-control-field);
}

.card .side {
  display: flex;
  grid-row: 1 / span 2;
  grid-column: 2;
  flex-direction: column;
  gap: var(--space-3);
  min-width: 0;
}

.send {
  gap: var(--space-6px);
  justify-content: center;
  height: var(--h-control-field);
  padding: var(--space-0) var(--space-3);
  font-size: var(--fs-label-md);
  font-weight: var(--fw-bold);
  color: var(--text);
  background: var(--bg-card);
  border-radius: var(--radius-sm);
}

.card .open {
  gap: var(--space-6px);
  align-self: flex-start;
  width: auto;
  height: var(--h-control-field);
  font-size: var(--fs-label-md);
}
